import { FunctionComponent } from "react";
import styles from "./CancelButton.module.css";

interface CancelButtonProps{
  handleCancel : () => void
}
const CancelButton: FunctionComponent<CancelButtonProps> = ({handleCancel}) => {
  return (
    <div className={styles.buttons} onClick={handleCancel}>
      <b className={styles.reset}>Reset</b>
    </div>
  );
};

export default CancelButton;
